import React from 'react';
import FranquiciasForm from './FranquiciasForm';

const NuevaFranquicias = () => {
    return <FranquiciasForm mode="ADD" />;
};

export default NuevaFranquicias;
